/* STEFANO - modulo reso (solo pagina reso) */
(function () {
  var CONFIG = {
    store_id: 'panthos',
    gas_url:
      'https://script.google.com/macros/s/AKfycbzKENQdkjqQcdxlIqkvskyJ60x4yXPTuW6nTIAsj_MRT8KnLu1gw7L6x3lJM42SE4qp3w/exec',
  };

  var i18n = {
    it: {
      title: 'Richiedi reso',
      subtitle:
        'Hai 14 giorni dalla ricezione del prodotto per esercitare il diritto di recesso. Compila il modulo per avviare la procedura.',
      label_name: 'Nome e cognome',
      label_email: 'Indirizzo email',
      label_order: 'Numero ordine',
      label_product: 'Prodotto/i da recedere',
      label_notes: 'Note / Motivo (facoltativo)',
      step2_label: 'Conferma recesso',
      step2_text:
        "Confermo di voler esercitare il diritto di recesso per l'ordine indicato e dichiaro di essere consapevole che il prodotto dovrà essere restituito entro 14 giorni dalla presente comunicazione.",
      btn_submit: 'Conferma recesso',
      msg_ok:
        'Richiesta inviata. Riceverai una email di conferma con il riepilogo e il timestamp della tua richiesta.',
      msg_err: 'Si è verificato un errore. Riprova o contattaci direttamente.',
      msg_required:
        'Compila tutti i campi obbligatori, spunta la casella di conferma e completa la verifica di sicurezza.',
      legal:
        "Ricordiamo che non è possibile richiedere il reso di occhiali graduati o personalizzati. Il presente modulo vale come comunicazione formale di recesso ai sensi dell'art. 52 del Codice del Consumo (D.Lgs. 206/2005) e della Direttiva UE 2023/2673. Al momento dell'invio verrà registrato il timestamp della richiesta.",
    },
    en: {
      title: 'Withdraw from contract',
      subtitle:
        'You have 14 days from receipt of the product to exercise your right of withdrawal. Fill in the form to start the process.',
      label_name: 'Full name',
      label_email: 'Email address',
      label_order: 'Order number',
      label_product: 'Product(s) to withdraw',
      label_notes: 'Notes / Reason (optional)',
      step2_label: 'Confirm withdrawal',
      step2_text:
        'I confirm that I wish to exercise my right of withdrawal for the order indicated above and acknowledge that the product must be returned within 14 days of this notice.',
      btn_submit: 'Confirm withdrawal',
      msg_ok:
        'Request submitted. You will receive a confirmation email with a summary and timestamp of your request.',
      msg_err: 'An error occurred. Please try again or contact us directly.',
      msg_required:
        'Please fill in all required fields, check the confirmation box and complete the security check.',
      legal:
        'Please note that it is not possible to request a return on prescription or personalized glasses. This form constitutes formal notice of withdrawal pursuant to EU Directive 2023/2673 and applicable national consumer law. The timestamp of submission will be recorded.',
    },
  };

  var pageLoadedAt = Date.now();
  var lang = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  var t = i18n[lang] || i18n.it;

  function value(id) {
    return document.getElementById(id).value.trim();
  }

  function init() {
    var form = document.getElementById('wr-form');
    if (!form) return;

    var submitBtn = document.getElementById('wr-submit-btn');
    var okEl = document.getElementById('wr-ok');
    var errEl = document.getElementById('wr-err');

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var text = t[el.getAttribute('data-i18n')];
      if (text !== undefined) el.textContent = text;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var payload = {
        store_id: CONFIG.store_id,
        name: value('wr-name'),
        email: value('wr-email'),
        order: value('wr-order'),
        product: value('wr-product'),
        notes: value('wr-notes'),
        timestamp: new Date().toISOString(),
        hp: document.getElementById('wr-website').value,
        elapsed: Date.now() - pageLoadedAt,
        ts_token: (form.querySelector('[name="cf-turnstile-response"]') || {}).value || '',
      };

      okEl.classList.remove('show');
      errEl.classList.remove('show');

      var confirmed = document.getElementById('wr-confirm').checked;
      if (!payload.name || !payload.email || !payload.order || !payload.product || !confirmed || !payload.ts_token) {
        errEl.textContent = t.msg_required;
        errEl.classList.add('show');
        return;
      }

      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      fetch(CONFIG.gas_url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload),
      })
        .then(function () {
          // no-cors: risposta opaca, si assume l'invio riuscito
          okEl.textContent = t.msg_ok;
          okEl.classList.add('show');
          form.reset();
          pageLoadedAt = Date.now();
        })
        .catch(function () {
          errEl.textContent = t.msg_err;
          errEl.classList.add('show');
        })
        .finally(function () {
          // il token Turnstile è monouso
          if (window.turnstile) window.turnstile.reset();
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
